import { render, staticRenderFns } from "./HdsChip.vue?vue&type=template&id=986985e4&scoped=true&"
import script from "./HdsChip.vue?vue&type=script&lang=ts&"
export * from "./HdsChip.vue?vue&type=script&lang=ts&"
import style0 from "./HdsChip.vue?vue&type=style&index=0&id=986985e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986985e4",
  null
  
)

export default component.exports